










import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Base64 } from 'js-base64';

import { PoiVideo } from '@/models/poi';
import { urlize } from '@/utils';

@Component
export default class PoiSlideVideo extends Vue {

    @Prop(Object) public model: PoiVideo;
    @Prop({ type: Boolean, default: true }) public enabled: boolean;

    get videoUrl() {
        return urlize(this.model.video);
    }

    get imageUrl() {
        return urlize(this.model.preview.medium);
    }

    public onPlayClicked() {
        if (!this.enabled) return;

        const videoUrlEncoded = Base64.encode(this.videoUrl);
        this.$f7router.navigate(`/videoplayer/${videoUrlEncoded}/`);

        this.$ga.event({
            eventCategory: 'poi',
            eventAction: 'playVideo',
            eventLabel: this.model.video,
        });
    }
}
